// src/components/common/EditModePanel.js
import React, { useState } from 'react';

const EditModePanel = ({ 
  sensorOrder, 
  sensorNicknames, 
  toggleEditMode,
  setSensorNicknames,
  setSensorOrder,
  getSensorDisplayName
}) => {
  const [editingNickname, setEditingNickname] = useState(null);
  const [currentNickname, setCurrentNickname] = useState('');
  
  const startEditingNickname = (sensor) => {
    setEditingNickname(sensor);
    setCurrentNickname(sensorNicknames[sensor] || '');
  };

  const saveNickname = () => {
    if (editingNickname) {
      if (currentNickname.trim() === '') {
        // Se il nickname è vuoto, rimuovilo
        const newNicknames = {...sensorNicknames};
        delete newNicknames[editingNickname];
        setSensorNicknames(newNicknames);
      } else {
        // Altrimenti, salvalo
        setSensorNicknames({
          ...sensorNicknames,
          [editingNickname]: currentNickname.trim()
        });
      }
      setEditingNickname(null);
    }
  };

  const cancelNicknameEdit = () => {
    setEditingNickname(null);
  };
  
  const moveSensorUp = (index) => {
    if (index <= 0) return;
    const newOrder = [...sensorOrder];
    [newOrder[index], newOrder[index - 1]] = [newOrder[index - 1], newOrder[index]];
    setSensorOrder(newOrder);
  };

  const moveSensorDown = (index) => {
    if (index >= sensorOrder.length - 1) return;
    const newOrder = [...sensorOrder];
    [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
    setSensorOrder(newOrder);
  };
  
  return (
    <div className="card mb-3 shadow-sm">
      <div className="card-header bg-primary text-white">
        <h3 className="fs-5 mb-0">Modifica sensori</h3>
      </div>
      <div className="card-body">
        <p className="small text-muted mb-3">
          Qui puoi rinominare i sensori e modificare l'ordine di visualizzazione.
        </p>
        
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Nome originale</th>
                <th>Nome personalizzato</th>
                <th>Ordine</th>
              </tr>
            </thead>
            <tbody>
              {sensorOrder.map((sensor, index) => (
                <tr key={sensor}>
                  <td>{sensor}</td>
                  <td>
                    {editingNickname === sensor ? (
                      <div className="input-group input-group-sm">
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          value={currentNickname}
                          onChange={(e) => setCurrentNickname(e.target.value)}
                          placeholder="Nome personalizzato"
                        />
                        <button className="btn btn-outline-success" onClick={saveNickname}>
                          <i className="bi bi-check"></i>
                        </button>
                        <button className="btn btn-outline-danger" onClick={cancelNicknameEdit}>
                          <i className="bi bi-x"></i>
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-between align-items-center">
                        <span>{getSensorDisplayName(sensor) !== sensor ? getSensorDisplayName(sensor) : '-'}</span>
                        <button 
                          className="btn btn-sm btn-outline-primary" 
                          onClick={() => startEditingNickname(sensor)}
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="btn-group btn-group-sm">
                      <button 
                        className="btn btn-outline-secondary" 
                        onClick={() => moveSensorUp(index)}
                        disabled={index === 0}
                      >
                        <i className="bi bi-arrow-up"></i>
                      </button>
                      <button 
                        className="btn btn-outline-secondary" 
                        onClick={() => moveSensorDown(index)}
                        disabled={index === sensorOrder.length - 1}
                      >
                        <i className="bi bi-arrow-down"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="mt-3 d-flex justify-content-end">
          <button className="btn btn-primary" onClick={toggleEditMode}>
            Salva e chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditModePanel;